import { render, staticRenderFns } from "./NewDraggableOptionComponent.vue?vue&type=template&id=6bc2940c"
import script from "./NewDraggableOptionComponent.vue?vue&type=script&lang=js"
export * from "./NewDraggableOptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports